import { createApp } from 'vue';
import store from './store';
	
import App from './app';

import './scss/index.scss'


class Main {
	constructor() {
		this.dataLoaded = false;
		// make sure elements (and thus hooks in the page are rendered);
		let sel = '#knd-c02';
		
		this.createComponent(sel, App);
	}

	createComponent(sel, comp) { 
		const app = createApp(comp);

		let htmlReady = this.htmlReady().then(() => {
			this.setLoader(sel);
		});

		let loadDate = store.dispatch('loadData');

		Promise.all([htmlReady, loadDate]).then(data => {
			this.dataLoaded = true;
			app.use(store);
			app.mount(sel);
		})
	}

	setLoader(sel) {
		if(this.dataLoaded) return;
		
		let el = document.querySelector(sel);

		if(el) {
			let div = document.createElement("div")
			div.classList.add('knd-loader');
			el.append(div);				
		}		
	}

	htmlReady() {
    return new Promise((resolve, reject) => {
        // in case the document is already rendered
        if (document.readyState !== 'loading') {
            resolve();
        }
        // modern browsers
        else if (document.addEventListener) {
            document.addEventListener('DOMContentLoaded', resolve);
        }
        // IE <= 8
        else {
            document.attachEvent('onreadystatechange', () => {
                if (document.readyState == 'complete') {
                    resolve();
                }
            });
        }
			});
	}
}

let main = new Main();
